import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  CenteredText,
  ContainerNivel,
  HelpText,
  ImgContainer,
  InfoScore,
  LevelText,
  ScoreContainer,
  Icon,
  LinkSpn
} from './styles';

import { createSvgComponent, getColorLevel } from '../../helpers/utils';
import IconDonwReputation from '../../assets/icons/down_calificacion.svg';
import IconUpReputation from '../../assets/icons/up_calificacion.svg';

const PublisherScoreSection = ({ device, reputationLevel, error, sendCustomTrackingInfo }) => {
  const [level, setLevel] = useState(0);
  const SvgComponent = createSvgComponent(reputationLevel.level || 0);

  const { t } = useTranslation();

  useEffect(() => {
    if (reputationLevel && reputationLevel.level) {
      setLevel(reputationLevel.level);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reputationLevel]);

  const handleClickHelp = () => {
    window.open(t('panel.reputation.help.url'));
    sendCustomTrackingInfo({
      event: 'select_content',
      content_type: 'Estadisticas - Reputación',
      item_id: 'Ayuda'
    });
  };

  return (
    <ContainerNivel>
      <ScoreContainer device={device}>
        <LevelText className='ScoreRating' color={getColorLevel(level)}>
          {t(`panel.reputacion.scoring.level.${level}`)}
        </LevelText>
        {reputationLevel.levelComparison !== null &&
          reputationLevel.levelComparison !== undefined &&
          reputationLevel.levelComparison !== 0 && (
            <InfoScore levelComparison={reputationLevel.levelComparison}>
              <Icon icon={reputationLevel.levelComparison === 1 ? IconUpReputation : IconDonwReputation} />
              <p>
                {t(
                  reputationLevel.levelComparison === 1
                    ? 'panel.reputacion.scoring.up'
                    : 'panel.reputacion.scoring.down'
                )}
              </p>
            </InfoScore>
          )}
      </ScoreContainer>
      <ImgContainer>
        <SvgComponent />
      </ImgContainer>
      <CenteredText>
        <p style={{ width: device === 'desktop' ? '326px' : '95%' }}>
          {t(reputationLevel.level ? 'panel.reputacion.scoring.bajada' : 'panel.reputacion.scoring.bajada.nodata')}
        </p>
      </CenteredText>
      <HelpText device={device}>{t('panel.reputacion.scoring.second.title')}</HelpText>
      <CenteredText>
        {t('panel.reputacion.scoring.second.bajada')}

        <LinkSpn onClick={handleClickHelp}>{t('panel.reputacion.scoring.second.bajada.link')}</LinkSpn>
      </CenteredText>
    </ContainerNivel>
  );
};

export default PublisherScoreSection;
